import { getName } from './string';

export const findArray = (arrList = [], id) => {
    if (arrList && arrList.length) return arrList.find(_ => _.value === id)
}

export const loadOptions = (input, cb, list, limit = 10) => {
    const result = list?.filter(i => {
        const term = i?.label || i?.name || getName(i);
        return term ? term.toLowerCase().includes(input?.toLowerCase()) : false;
    });
    cb?.(limit ? result?.slice(0, limit) : result);
}

export const getKeyName = (arrList = [], id) => {
    if (arrList && arrList?.length) {
        return arrList?.find(_ => {
            if (_) {
                if (id == null) {
                    return ('value' in _ && _.value === id) || ('_id' in _ && _._id === id);
                }
                if (id === '' && (_.value === 0 || _.value === false || _._id === 0 || _._id === false)) {
                    return false;
                }
                if ((id === 0 || id === false) && (_.value === '' || _._id === '')) {
                    return false;
                }
                return _.value == id || _._id == id;
            }
            return false;
        });
    }
}

export const getLabelValueArray = (arrName = [], label = 'name', value = '_id') => {
    const finalArray = []
    arrName?.forEach(e => {
        /** ...e for get all values, used in ATS source */
        let data = {...e, label: label === 'fullName' ? getName(e) : e[label], value: e[value]}
        finalArray?.push(data)
    })
    return finalArray
}
export const getKeyValue = (arrName = [], label = 'name', value = '_id') => {
    const finalObject = {}
    arrName?.forEach(e => {
        finalObject[e[value]] = e[label]
    })
    return finalObject
}

export const getKeyObj = (arrName = [], value = '_id') => {
    const finalObject = {}
    arrName?.forEach(e => {
        finalObject[e[value]] = e
    })
    return finalObject
}

export const getLabelValue = (arrName = [], include, key = 'name') => {
    const finalArray = [];
    arrName?.forEach(e => {
        const label = key === 'fullName' ? getName(e) : e[key];

        let data = {
            ...e,
            label,
            value: e._id
        };

        // Match original exactly: gated on key non-empty + include truthy, no null-check on e[include]
        if (key?.length !== 0 && include) {
            data[include] = e[include];
        }

        finalArray.push(data);
    });
    return finalArray;
};
export const getLabelForFF = (arrName = []) => {
    const finalArray = []
    arrName?.forEach(e => finalArray?.push({label: `${e.firstName} ${e.lastName}`, value: e._id}))
    return finalArray
}

export const getContryLanguageLabelValue = (arrName = []) => {
    const finalArray = []
    arrName?.forEach(e => finalArray?.push({label: e.name, value: e.name}))
    return finalArray
}

export const getLanguageKeyValue = (arrName) => {
    const finalObject = {}
    arrName?.forEach(e => {
        finalObject[e.name] = e.name
    })
    return finalObject
}

export const getLabelValueFromId = (arrList = [], id, key = '_id', label = 'name') => {
    if (arrList && arrList?.length) {
        const data = arrList?.find(_ => _[key] === id)
        if (data) return {label: data?.[label], value: data?.[key]}
        else return null
    }
}

export const getKeyLabel = (arrList = [], id) => {
    if (arrList && arrList?.length) return arrList?.find(_ => _.value === id)?.label;
}

export const getKeyValueColorCode = (arrName = []) => {
    const finalObjectColor = {}
    arrName?.forEach(e => {
        finalObjectColor[e._id] = e.color
    })
    return finalObjectColor
}

export const getUserInfoObject = (userInfo = {}, empID = false) => {
    const baseName = getName(userInfo);
    // Match variant 1 exactly: employeeId appended only when empID flag truthy AND value exists
    const label = empID
        ? `${baseName} ${userInfo?.employeeId || ''}`.trim()
        : baseName;

    return {
        ...userInfo,
        label,
        name: label, // only safe to add if confirmed unused by old `name` field elsewhere
        // Safe Fallback: handles user (Payroll selector), value (Framework/Payroll userInfo), and _id (Common)
        value: userInfo?.user || userInfo?.value || userInfo?._id || '',
        employeeId: userInfo?.employeeId || '' // guaranteed key, matches variant 1 exactly
    };
};

export const getLabelValueUserImage = (arrName = [], empID = false) => {
    const finalArray = [];
    arrName?.forEach(e => {
        finalArray.push(getUserInfoObject(e, empID));
    });
    return finalArray;
};

export const getSplitRange = (range, operator = '-', startKey = 'from', endKey = 'to') => {
    let obj;
    let arr = range.split(operator)
    if (arr.length !== 1) {
        obj = {
            [startKey]: +arr[0],
            [endKey]: +arr[1]
        }
    } else obj = {[startKey]: +arr[0].replace('+', '').slice(0, 3)}
    return obj
}
